import { useIntl } from 'react-intl';

import BirthdayCakeIconPath from '@starbucks-web/pattern-library/lib/icons/birthday-cake';
import PhysicalCardPath from '@starbucks-web/pattern-library/lib/icons/physical-card';
import TimerPath from '@starbucks-web/pattern-library/lib/icons/timer';
import PersonalCupPath from '@starbucks-web/pattern-library/lib/icons/personal-cup';
import SparklePath from '@starbucks-web/pattern-library/lib/icons/sparkle';
import TierStarPath from '@starbucks-web/pattern-library/lib/icons/tier-star';
import TicketPath from '@starbucks-web/pattern-library/lib/icons/ticket';
import TierTrophyPath from '@starbucks-web/pattern-library/lib/icons/tier-trophy';

import messages from './messages';

const icons = {
  birthdayCake: { path: BirthdayCakeIconPath },
  personalCup: { path: PersonalCupPath },
  physicalCard: { path: PhysicalCardPath },
  sparkle: { path: SparklePath },
  ticket: { path: TicketPath },
  tierStar: { path: TierStarPath },
  timer: { path: TimerPath },
  trophy: { path: TierTrophyPath },
};

export const getTiers = () => {
  const { formatMessage } = useIntl();
  return [
    {
      name: formatMessage(messages.green),
      tierRangeText: formatMessage(messages.greenRange),
      bgColor: 'bg-greenLoyaltySurfaceGreen',
      color: 'color-greenOnPrimary',
      iconStrokeColor: 'color-greenOnPrimary',
      items: [
        {
          icon: icons.birthdayCake,
          text: formatMessage(messages.greenPerkItem1),
        },
        { icon: icons.tierStar, text: formatMessage(messages.greenPerkItem2) },
        {
          icon: icons.ticket,
          text: formatMessage(messages.greenPerkItem3),
        },
        {
          icon: icons.trophy,
          text: formatMessage(messages.greenPerkItem4),
        },
        {
          icon: icons.personalCup,
          text: formatMessage(messages.greenPerkItem5),
        },
      ],
    },
    {
      name: formatMessage(messages.gold),
      tierRangeText: formatMessage(messages.goldRange),
      bgColor: 'bg-goldLoyaltySurfaceGold',
      color: 'color-greenOnPrimary',
      iconStrokeColor: 'color-gold600',
      items: [
        {
          icon: icons.birthdayCake,
          text: formatMessage(messages.goldPerkItem1),
        },
        { icon: icons.tierStar, text: formatMessage(messages.goldPerkItem2) },
        { icon: icons.timer, text: formatMessage(messages.goldPerkItem3) },
        {
          icon: icons.ticket,
          text: formatMessage(messages.goldPerkItem4),
        },
        {
          icon: icons.trophy,
          text: formatMessage(messages.goldPerkItem5),
        },
        {
          icon: icons.personalCup,
          text: formatMessage(messages.goldPerkItem6),
        },
        {
          icon: icons.physicalCard,
          text: formatMessage(messages.goldPerkItem7),
        },
      ],
    },
    {
      name: formatMessage(messages.reserve),
      tierRangeText: formatMessage(messages.reserveRange),
      bgColor: 'bg-blackLoyaltySurfaceReserve',
      color: 'color-whiteOnAccent2',
      iconStrokeColor: 'color-gold300',
      items: [
        {
          icon: icons.birthdayCake,
          text: formatMessage(messages.reservePerkItem1),
        },
        {
          icon: icons.tierStar,
          text: formatMessage(messages.reservePerkItem2),
        },
        { icon: icons.timer, text: formatMessage(messages.reservePerkItem3) },
        {
          icon: icons.ticket,
          text: formatMessage(messages.reservePerkItem4),
        },
        {
          icon: icons.trophy,
          text: formatMessage(messages.reservePerkItem5),
        },
        {
          icon: icons.personalCup,
          text: formatMessage(messages.reservePerkItem6),
        },
        {
          icon: icons.sparkle,
          text: formatMessage(messages.reservePerkItem7),
        },
        {
          icon: icons.physicalCard,
          text: formatMessage(messages.reservePerkItem8),
        },
      ],
    },
  ];
};
